export default {
  trimDotIfLastCharacter(str: string = ''): string {
    if (str.endsWith('.')) {
      return str.slice(0, -1);
    }
    return str;
  },
  preventEmptyParagraph(htmlValue: string = ''): string {
    const sanitizedValue = htmlValue.replace(/&nbsp;|\u00A0/g, ' ');
    return sanitizedValue === '<p></p>' ? '' : htmlValue;
  },
};
